(function () {
    'use strict';

    angular
        .module('actionPlanEditModule', [
            'services.authenticatedUser',
            'services.historyCtxt',
            'actionPlanModule',
            'recommendationModule'
        ]);
})();
